import { formattingNumber } from './../utils'
export const generate_old_new_option = () => ({
    title: {
        text: '',
        textStyle: {
            color:'#808080',
            fontSize: 20,
        },
        top: 10,
        left: 'center',
    },
    tooltip: {
        trigger: 'axis',
        axisPointer: {
            type: 'cross',
            label: {
                backgroundColor: '#6a7985'
            }
        }
    },
    color: ['#7FBDF2', '#5AC4A0'],
    legend: {
        show:true,
        // 位置
        bottom: '2%',
        // 样式
        icon: 'rect',
        textStyle: {
            fontSize:16,
            lineHeight:20,
            fontWeight: 'bold'
        },
        data: ['老用户', '新用户']
    },
    grid: {
        show: false, // 不显示网格
        containLabel: true,
        top: 100,
        left: '3%',
        right: '3%',
        bottom: '10%',
        borderWidth: 0, 
    },
    xAxis: [
        {
            show: true,
            type: 'category',
            boundaryGap: false,
            data: [],
            splitLine: {
              show: false
            }
        }
    ],
    yAxis: [
        {
            type: 'value',
            show:true,
            axisLine: {
                show:false
            },
            axisLabel: {
                show: true,
                margin: 20,
            },
            minorSplitLine: {
                show: false
            },
            name: '',
            nameTextStyle: {
                color: '#969696',
                padding: [0, 0, 0, 20]  
            }
        }
    ],
    series: [
        {
            name: '老用户',
            type: 'line',
            stack: '总量',
            areaStyle: {},
            // data: [120, 132, 101, 134, 90, 230, 210]
        },
        {
            name: '新用户',
            type: 'line',
            stack: '总量',
            areaStyle: {},
            // data: [220, 182, 191, 234, 290, 330, 310]
        },
        {
            name: "全选",
            type:'line',
            label: {
                color: '#C0C0C0',
                show: false,
                position: 'top',
                formatter(params) {
                    return formattingNumber(params.value, 0) || ''
                },
                distance: 10,
            },
            symbol:'circle',
            symbolSize:1,
            hoverAnimation:false,
            lineStyle:{
                opacity : 0,
            },
            itemStyle:{
               color:'rgba(0,0,0,0)'
            }, 
            data: []
        }
    ]
});

// export const title_legend = ['老用户', '新用户']


export const generate_low_high_option = () => ({
    title: {
        text: '',
        textStyle: {
            color:'#808080',
            fontSize: 20,
        },
        top: 10,
        left: 'center',
    },
    tooltip: {
        trigger: 'axis',
        axisPointer: {
            type: 'cross',
            label: {
                backgroundColor: '#6a7985'
            }
        }
    },
    color: ['#5AC4A0', '#7FBDF2', '#ACCB81'],
    legend: {
        data: ['低价课', '平价课', '高价课'],
        show:true,
        // 位置
        bottom: '2%',
        // 样式
        icon: 'rect',
        textStyle: {
            fontSize:16,
            lineHeight:20,
            fontWeight: 'bold'
        }
    },
    grid: {
        show: false, // 不显示网格
        containLabel: true,
        top: 100,
        left: '3%',
        right: '3%',
        bottom: '10%',
        borderWidth: 0, 
    },
    xAxis: [
        {
            show: true,
            type: 'category',
            boundaryGap: false,
            data: [],
            splitLine: {
              show: false
            }
        }
    ],
    yAxis: [
        {
            type: 'value',
            show:true,
            axisLine: {
                show:false
            },
            axisLabel: {
                show: true,
                margin: 20,
            },
            minorSplitLine: {
                show: false
            },
            name: '',
            nameTextStyle: {
                color: '#969696',
                padding: [0, 0, 0, 20]  
            }
        }
    ],
    series: [
        {
            name: '低价课',
            type: 'line',
            stack: '总量',
            areaStyle: {},
            data:[]
        },
        {
            name: '平价课',
            type: 'line',
            stack: '总量',
            areaStyle: {},
            data:[]
        },
        {
            name: '高价课',
            type: 'line',
            stack: '总量',
            areaStyle: {},
            data:[]
        },
    ]
});